import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';
import { CmpsDialog } from '@cmps/ng-uikit';
import { tap } from 'rxjs/operators';

import { SecurityScope } from '../../../auth/auth.model';
import { takeUntilDestroy } from '../../../common/take-until-destroy.decorator';
import { SearchUserContainerComponent } from '../../../user/search-user.container.component';
import { User } from '../../../user/user.model';
import { Scorecard } from '../../scorecard-next.model';
import { PeriodType, PeriodTypeShallow } from '../../scorecard.model';
import { HistoryPositionNavigate } from '../general/history-position-navigate.model';
import { HistoryPosition } from '../general/history-position.model';
import { TranslationKeyMap } from '../pulse-widget.i18n';

@Component({
    selector: 'cmps-sw-detail',
    templateUrl: './pw-detail.component.html',
    host: {
        class: 'cmps-sw-detail',
    },
})
export class SwDetailComponent implements OnDestroy {
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _periodTypes: any[];
    /** @private */ _selectedPeriodType: PeriodType;

    @Input() user: User;
    @Input() scorecard: Scorecard;
    @Input() historyPosition: HistoryPosition;
    // eslint-disable-next-line accessor-pairs
    @Input() set periodTypes(value: PeriodTypeShallow[]) {
        this._periodTypes = [];
        if (value) {
            value.forEach((p) => {
                this._periodTypes.push({
                    value: p.periodTypeId,
                    label: p.periodTypeName,
                    isDefault: p.periodTypeId === this.selectedPeriodType,
                });
            });
        }
    }

    // eslint-disable-next-line accessor-pairs
    @Input() set selectedPeriodType(value: PeriodType) {
        this._selectedPeriodType = value;
    }

    @Output() userSelect: EventEmitter<User>;
    @Output() navigate: EventEmitter<HistoryPositionNavigate>;
    @Output() onPeriodTypeChange: EventEmitter<string>;
    @Output() onPeriodTypeFocus: EventEmitter<void>;

    constructor(private readonly _dialog: CmpsDialog) {
        this.userSelect = new EventEmitter();
        this.navigate = new EventEmitter();
        this.onPeriodTypeChange = new EventEmitter();
        this.onPeriodTypeFocus = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.userSelect.complete();
        this.navigate.complete();
        this.onPeriodTypeChange.complete();
        this.onPeriodTypeFocus.complete();
    }

    /** @private */ _onSearchUserClick(): void {
        const ref = this._dialog.open<SearchUserContainerComponent, any, User>(
            SearchUserContainerComponent,
            {
                data: {
                    userId: this.scorecard
                        ? this.scorecard.header.userId
                        : null,
                    scope: SecurityScope.SCORECARD,
                },
            },
        );
        ref.result
            .pipe(
                tap((user) => {
                    if (user != null) {
                        this.userSelect.emit(user.copy());
                    }
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    /** @private */ _onPrevClick(): void {
        this.navigate.emit({ direction: -1 });
    }

    /** @private */ _onNextClick(): void {
        this.navigate.emit({ direction: 1 });
    }

    /** @private */ _onPeriodTypeFocus(): void {
        this.onPeriodTypeFocus.emit();
    }

    /** @private */ _onPeriodTypeChange(periodType: string): void {
        this.onPeriodTypeChange.emit(periodType);
    }
}
